export default __webpack_public_path__ + "static/media/flesh.f42ea6a9.png";